



































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle }  from '@/shared/msw-app-title';
import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { MswApiService } from '../../shared/msw-api-service';
import { InfoState } from '../../core/core.store';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { ColumnsAdjustRequestData, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
const cssPrefix = 'transferServicesForSecureUpgrade';
@Component({
  components:{
    ...UUIFComponents,
    MswAppTitle,
    SwButton,
  },
})
export default class TransferServiceForSecureUpgrade extends SwExtendedVue {
  cssPrefix = cssPrefix;

  fromSrNo: string = '';
  toSrNo: string = '';
  upgradeId: string = '';
  snbuser: string = '';

  rowData: any[] = [];
  transferServiceTableConfig: TableColumnConfig[] = [];

  applicablePath: string = 'applicablePromotions';
  promoHistPath: string = 'promotionHistory';
  promoHistPathSandbox: string = 'promotionHistory';
  mounted() {
    if (this.$router.currentRoute.query.frm &&
        this.$router.currentRoute.query.to &&
        this.$router.currentRoute.query.upgradeID &&
        this.$router.currentRoute.query.snbuser) {
      const params = this.$router.currentRoute.query;
      this.fromSrNo = params.frm.toString();
      this.toSrNo = params.to.toString();
      this.upgradeId = params.upgradeID.toString();
      this.snbuser = params.snbuser.toString();
      this.getTransferGridData();
    }
  }
  getTransferGridData() {
    this.$store.commit('startLoading');
    MswApiService.promotions.getTransferGridData(this.fromSrNo, this.toSrNo, this.upgradeId)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.rowData.push(resp.hasOwnProperty('content') ? resp.content : {});
        console.warn(resp.content);
      } else {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc ? resp.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((errorResponse: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
      this.$store.commit('displayMessage', message);
    });
  }
  get getTransferServiceTableConfig() {
    this.transferServiceTableConfig = [{
      key: 'index',
      type: 'index',
    }, {
      key: 'fromSerialDescription',
      dataKey: 'fromSerialDescription',
      title:this.$t('myPromotions.trdUnit')
                .toString(),
      width: 300,
      scalable: true,
      render: (createElement, data: { entry: TableEntry }) => {
        return createElement('div', { domProps: { innerHTML: data.entry.fromSerialDescription } });
      },
    }, {
      key: 'toSerialDescription',
      dataKey: 'toSerialDescription',
      title: this.$t('myPromotions.upgrdUnit')
                 .toString(),
      width: 300,
      scalable: true,
      render: (createElement, data: { entry: TableEntry }) => {
        return createElement('div', { domProps: { innerHTML: data.entry.toSerialDescription } });
      },
    }];
    return this.transferServiceTableConfig;
  }
  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.getTransferServiceTableConfig.forEach((col: TableColumnConfig) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) { return; }
      Vue.set(col, 'width', adjustInfo);
    });
  }
  get tableHeight() {
    return 'calc(100vh - 355px)';
  }
  getWidth(percentageWidth: number) {
    const totalWidth = (this.$refs.tableWrapper as HTMLElement) ? (this.$refs.tableWrapper as HTMLElement).clientWidth : 0;
    return totalWidth > 0 ? (percentageWidth / 100) * totalWidth : 0;
  }
  get getTransferServiceTableData() : TableEntry[] {
    const tempArray : TableEntry[] = [];
    this.rowData &&
    this.rowData.length > 0 &&
    this.rowData.forEach((instance: any, index: number) => {
      tempArray.push({
        ...instance,
        _key : index.toString(),
      });
    });
    return tempArray;
  }
  transferServices() {
    this.$store.commit('startLoading');
    MswApiService.promotions.completeTransfer(this.fromSrNo, this.toSrNo, this.upgradeId)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        if (window.location.pathname.split('/')
            .includes('sandbox')) {
          this.$router.push({ path : this.promoHistPathSandbox, query: { data: '3', snbuser: this.snbuser, msg: resp.msgDesc  } });
        } else {
          this.$router.push({ path :  this.promoHistPath, query:  { data: '3', snbuser: this.snbuser, msg: resp.msgDesc } });
        }
      } else {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc ? resp.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((errorResponse: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  'Operation is unsuccesful' };
      this.$store.commit('displayMessage', message);
    });
  }
  applicablePromo() {
    this.$router.go(-1);
  }
}
